import { Text, TextProps } from "@chakra-ui/react";
import { RefObject, useRef } from "react";

export function ContentEditable({
  passedEditableRef,
  children,
  enabled,
  handleSubmit,
  ...props
}: {
  passedEditableRef?: RefObject<HTMLDivElement>;
  children?: React.ReactNode;
  enabled?: boolean;
  handleSubmit?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
} & TextProps) {
  const editableRef = useRef<HTMLDivElement>(null);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.ctrlKey && e.key === "Enter") {
      e.preventDefault();
      handleSubmit?.(e);
    }
  };

  return (
    <Text
      ref={passedEditableRef || editableRef}
      contentEditable={enabled}
      suppressContentEditableWarning
      onKeyDown={handleKeyDown}
      {...props}
    >
      {children}
    </Text>
  );
}
